export enum AEM_GREETING_TYPES {
    HOME_PAGE = 'Home page',
    SHOP_PAGE = 'Shop page',
}
